import React, { useState } from 'react';

/**
 * Drop-in replacement for <img className="content-image" />.
 * - Shows a shimmer skeleton while the image is loading.
 * - Fades in smoothly once loaded.
 * - Falls back to a styled placeholder on error or missing src.
 */
export default function CardImage({ src, alt }) {
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);

  if (!src || failed) {
    return (
      <div className="content-placeholder" aria-hidden="true">
        <svg
          width="48" height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ opacity: 0.35 }}
        >
          <rect x="4" y="10" width="40" height="28" rx="3" stroke="white" strokeWidth="2.5" fill="none"/>
          <rect x="7"  y="14" width="5" height="4" rx="1" fill="white"/>
          <rect x="7"  y="22" width="5" height="4" rx="1" fill="white"/>
          <rect x="7"  y="30" width="5" height="4" rx="1" fill="white"/>
          <rect x="36" y="14" width="5" height="4" rx="1" fill="white"/>
          <rect x="36" y="22" width="5" height="4" rx="1" fill="white"/>
          <rect x="36" y="30" width="5" height="4" rx="1" fill="white"/>
          <path d="M20 18.5 L20 29.5 L31 24 Z" fill="white"/>
        </svg>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt ?? ''}
      className={`content-image${loaded ? ' content-image--loaded' : ''}`}
      loading="lazy"
      onLoad={() => setLoaded(true)}
      onError={() => setFailed(true)}
    />
  );
}
